import Vue from 'vue';
import _ from 'lodash';
import { db, docFromSnapshot, docsFromSnapshot } from '@/firebase';
import {
  applySmartbooksHoursToStores,
  fetchSmartbooksShopfrontHours
} from '@/smartbooksShopfront';

const state = {
  stores: {},
  storeId: null,
  storeAggregations: {},
  storeAggregationId: null
};

const getters = {
  stores: state => state.stores,
  storesList: state => Object.values(state.stores),
  storesEnabledForOnlineBookings: state =>
    Object.values(state.stores).filter(store => store.isOnlineBookingsEnabled),
  storesExcludingCurrentStore: state =>
    Object.values(state.stores).filter(store => store._id !== state.storeId),
  storeId: state => state.storeId,
  store: state => state.stores[state.storeId] || {},
  storeAggregation: state =>
    _.get(state.storeAggregations, state.storeAggregationId, {})
};

const actions = {
  async fetchStores(context) {
    if (context.getters.storesList.length) return;

    const [snap, shopfrontHours] = await Promise.all([
      db.collection('stores').get(),
      fetchSmartbooksShopfrontHours()
    ]);
    const stores = applySmartbooksHoursToStores(
      docsFromSnapshot(snap),
      shopfrontHours
    );

    context.commit('SET_STORES', stores);
  },
  async setStore(context, id) {
    context.commit('SET_STORE', id);
  },
  async updateStore(context, store) {
    store.timestamp = +new Date();

    await db
      .collection('stores')
      .doc(store._id)
      .set(store);

    context.commit('SET_STORE_IN_STORES', store);
  },
  async fetchStoreAggregation(context, storeId) {
    if (!context.state.storeAggregations[storeId]) {
      const snap = await db
        .collection('aggregations')
        .doc(storeId)
        .get();

      context.commit('SET_STORE_AGGREGATION_IN_AGGREGATIONS', {
        storeId,
        storeAggregation: docFromSnapshot(snap)
      });
    }

    context.commit('SET_STORE_AGGREGATION', storeId);
  },
  async clearStoreAggregation(context) {
    context.commit('CLEAR_STORE_AGGREGATION');
  }
};

const mutations = {
  SET_STORES(state, stores) {
    state.stores = stores;
  },
  SET_STORE_IN_STORES(state, store) {
    Vue.set(state.stores, store._id, store);
  },
  SET_STORE(state, id) {
    state.storeId = id;
  },
  SET_STORE_AGGREGATION_IN_AGGREGATIONS(state, { storeId, storeAggregation }) {
    state.storeAggregations[storeId] = storeAggregation;
  },
  SET_STORE_AGGREGATION(state, storeId) {
    state.storeAggregationId = storeId;
  },
  CLEAR_STORE_AGGREGATION(state) {
    state.storeAggregationId = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
